import { render, staticRenderFns } from "./PendingTransactions.vue?vue&type=template&id=2965281e&scoped=true&"
import script from "./PendingTransactions.vue?vue&type=script&lang=js&"
export * from "./PendingTransactions.vue?vue&type=script&lang=js&"
import style0 from "./PendingTransactions.vue?vue&type=style&index=0&id=2965281e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2965281e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VRow})
